import "./pagination.css";

/**
 * Reusable pagination control.
 * Renders nothing when there is only a single page.
 */
export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  // Build a compact page list with ellipses: 1 … (p-1) p (p+1) … N
  const pages = [];
  const push = (v) => pages.push(v);

  push(1);
  const start = Math.max(2, currentPage - 1);
  const end = Math.min(totalPages - 1, currentPage + 1);

  if (start > 2) push("…");
  for (let i = start; i <= end; i++) push(i);
  if (end < totalPages - 1) push("…");
  if (totalPages > 1) push(totalPages);

  const go = (p) => {
    if (p < 1 || p > totalPages || p === currentPage) return;
    onPageChange(p);
  };

  return (
    <nav className="pagination" aria-label="Phân trang">
      <button
        className="page-btn page-nav"
        onClick={() => go(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Trang trước"
      >
        <i className="fas fa-chevron-left"></i>
      </button>

      {pages.map((p, idx) =>
        p === "…" ? (
          <span key={`gap-${idx}`} className="page-ellipsis">…</span>
        ) : (
          <button
            key={p}
            className={`page-btn ${p === currentPage ? "active" : ""}`}
            onClick={() => go(p)}
          >
            {p}
          </button>
        )
      )}

      <button
        className="page-btn page-nav"
        onClick={() => go(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Trang sau"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </nav>
  );
}
